/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Modal,
  Row,
  Typography,
} from 'antd';
import CurrencyInput from 'components/CurrencyInput';
import Table from 'components/Table';
import FormSubmitControls from 'components/FormSubmitControls';
import ModalDelete from 'components/ModalDelete';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { onAlert } from 'utils/handlers';
import { getModelPermission } from 'utils/permission';
import { getNombramiento } from 'api/catalogos/Nombramientos';
import {
  getDatoOperacionalesDeEmpleados,
  patchDatoOperacionalDelEmpleado,
} from 'api/estructuraOrganizacional/datosOperacionalesDeEmpleados';
import { getPlazavistaOptimized } from 'api/catalogos/plazas';
import { getJornadasDetalle } from 'api/catalogos/JornadaDetalle';
import { getChecados } from 'api/catalogos/TiposDeChecado';
import {
  getHistorialesHorarioEmpleado,
  patchHistorialHorarioEmpleado,
  deleteHistorialHorarioEmpleado,
} from 'api/catalogos/historialHorarioEmpleado';
import Select from '../../Select';

const permissionHistorialHorarioEmpleado = {
  permissionModel: 'historialhorarioempleado',
  catalogsModels: [],
  tabsModels: [],
};

// eslint-disable-next-line react/prop-types
const EmpleadoAtributos = ({
  form,
  formGeneral,
  tipodeActividades,
  tiposDeContrataciones,
  jornadas,
  tiposDeSueldos,
  sindicatos,
  perioricidadesDePago,
  zonasDeSalariosMinimos,
  tiposRegimenesNominas,
  tiposDeNominasEmpleados,
  rules,
  isBlocked,
  caracteresDeNombramiento = [],
  empleado,
  nombramientosSinPaginar,
  plazaEmpleado,
  tiposEmpleados,
  tiemposDeContrataciones,
  tiposOrigenesContratacion,
  origenContratacionSeleccionado,
}) => {
  const [, setAplicaFirma] = useState(false);
  const [sindicalizado, setSindicalizado] = useState(false);
  const [datoOperacionalId, setDatoOperacionalId] = useState(null);
  const [jornadaDetalles, setJornadaDetalles] = useState([]);
  const [tiposDeChecado, setTiposDeChecado] = useState([]);
  const [historialHorario, setHistorialHorario] = useState([]);
  const [guardandoHorario, setGuardandoHorario] = useState(false);
  const [selectedHistorialHorarioKeys, setSelectedHistorialHorarioKeys] = useState([]);
  const [historialHorarioSeleccionado, setHistorialHorarioSeleccionado] = useState(null);
  const [editHistorialHorarioVisible, setEditHistorialHorarioVisible] = useState(false);
  const [guardandoEdicionHistorial, setGuardandoEdicionHistorial] = useState(false);
  const [visibleDeleteHistorialHorario, setVisibleDeleteHistorialHorario] = useState(false);
  const [eliminandoHistorialHorario, setEliminandoHistorialHorario] = useState(false);
  const [editHistorialForm] = Form.useForm();

  const permissionHistorialHorario = getModelPermission(
    permissionHistorialHorarioEmpleado.permissionModel,
    permissionHistorialHorarioEmpleado.catalogsModels,
    permissionHistorialHorarioEmpleado.tabsModels,
    false,
  );

  const historialHorarioCols = [
    {
      titleText: 'Fecha de Cambio',
      dataIndex: 'fecha_de_cambio',
      key: 'fecha_de_cambio',
      width: 130,
      render: (val) => (val ? moment(val).format('DD/MM/YYYY') : ''),
    },
    {
      titleText: 'Jornada',
      dataIndex: 'jornada_descripcion',
      key: 'jornada_descripcion',
      width: 120,
    },
    {
      titleText: 'Horario',
      dataIndex: 'horario_descripcion',
      key: 'horario_descripcion',
      width: 280,
    },
    {
      titleText: 'Horas Semanales',
      dataIndex: 'numero_de_horas_semanal',
      key: 'numero_de_horas_semanal',
      width: 140,
    },
    {
      titleText: 'Aplica Reloj Checador',
      dataIndex: 'aplica_reloj_checador',
      key: 'aplica_reloj_checador',
      width: 160,
      render: (val) => (val ? 'Sí' : 'No'),
    },
    {
      titleText: 'Tipo de Checado',
      dataIndex: 'tipo_de_checado_descripcion',
      key: 'tipo_de_checado_descripcion',
      width: 160,
    },
  ];

  const cargarHistorialHorario = async () => {
    setSelectedHistorialHorarioKeys([]);
    setHistorialHorarioSeleccionado(null);
    if (!empleado) {
      setHistorialHorario([]);
      return;
    }
    const historial = await getHistorialesHorarioEmpleado({ empleado });
    setHistorialHorario(historial || []);
  };

  const handleEditHistorialHorario = () => {
    if (!historialHorarioSeleccionado) return;
    editHistorialForm.setFieldsValue({
      jornada: historialHorarioSeleccionado.jornada,
      jornada_detalle: historialHorarioSeleccionado.jornada_detalle,
      aplica_reloj_checador: historialHorarioSeleccionado.aplica_reloj_checador,
      tipo_de_checado: historialHorarioSeleccionado.tipo_de_checado,
      fecha_de_cambio: historialHorarioSeleccionado.fecha_de_cambio
        ? moment(historialHorarioSeleccionado.fecha_de_cambio)
        : null,
    });
    setEditHistorialHorarioVisible(true);
  };

  const confirmDeleteHistorialHorario = async () => {
    if (!historialHorarioSeleccionado) return;
    try {
      setEliminandoHistorialHorario(true);
      const ok = await deleteHistorialHorarioEmpleado(historialHorarioSeleccionado.id);
      if (ok) {
        setVisibleDeleteHistorialHorario(false);
        await cargarHistorialHorario();
      }
    } finally {
      setEliminandoHistorialHorario(false);
    }
  };

  const handleGuardarEdicionHistorial = async () => {
    try {
      const values = await editHistorialForm.validateFields();
      setGuardandoEdicionHistorial(true);
      const saved = await patchHistorialHorarioEmpleado(historialHorarioSeleccionado.id, {
        ...values,
        fecha_de_cambio: values.fecha_de_cambio
          ? values.fecha_de_cambio.format('YYYY-MM-DD')
          : null,
      });
      if (saved) {
        setEditHistorialHorarioVisible(false);
        await cargarHistorialHorario();
      }
    } finally {
      setGuardandoEdicionHistorial(false);
    }
  };

  useEffect(() => {
    const fetchCatalogos = async () => {
      const [detalles, checados] = await Promise.all([
        getJornadasDetalle(),
        getChecados(),
      ]);
      setJornadaDetalles(detalles || []);
      setTiposDeChecado(checados || []);
    };
    fetchCatalogos();
  }, []);

  useEffect(() => {
    cargarHistorialHorario();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [empleado]);

  const guardarHorario = async () => {
    try {
      await form.validateFields(['jornada', 'jornada_detalle', 'aplica_reloj_checador', 'tipo_de_checado']);
    } catch (err) {
      return;
    }
    if (!datoOperacionalId) {
      onAlert('Aún no se puede guardar el horario: falta guardar al empleado primero.');
      return;
    }
    try {
      setGuardandoHorario(true);
      const values = form.getFieldsValue([
        'jornada', 'jornada_detalle', 'aplica_reloj_checador', 'tipo_de_checado',
      ]);
      const saved = await patchDatoOperacionalDelEmpleado(datoOperacionalId, values);
      if (saved) {
        form.setFieldsValue({ total_horas_solo_hrs: saved.total_horas_solo_hrs });
        await cargarHistorialHorario();
      }
    } finally {
      setGuardandoHorario(false);
    }
  };

  useEffect(() => {
    const toMoment = (val) => (val ? moment(val) : null);

    const fetch = async () => {
      try {
        if (!form || !empleado) return;

        const datosOp = await getDatoOperacionalesDeEmpleados({ empleado });
        if (!datosOp?.length) return;

        const dato = datosOp[0];
        setDatoOperacionalId(dato.id);
        form.setFieldsValue({
          jornada: dato.jornada,
          jornada_detalle: dato.jornada_detalle,
          tipo_de_checado: dato.tipo_de_checado,
          aplica_reloj_checador: dato.aplica_reloj_checador,
          total_horas_solo_hrs: dato.total_horas_solo_hrs,
        });

        // === 1. Nombramiento ===
        if (dato.nombramiento) {
          const nombramiento = await getNombramiento(dato.nombramiento);
          if (nombramiento) {
            form.setFieldsValue({
              tipo_de_nombramiento: nombramiento.descripcion_caracter_de_nombramiento,
              folio_de_nombramiento: nombramiento.folio,
              vigencia_de_nombramiento_inicio: toMoment(nombramiento.inicio_vigencia),
              vigencia_de_nombramiento_fin: toMoment(nombramiento.termino_de_vigencia),
              sueldo_mensual: nombramiento.sueldo_mensual,
              sueldo_diario: nombramiento.sueldo_mensual
                ? (nombramiento.sueldo_mensual / 30).toFixed(2)
                : null,
            });
          }
        }

        // === 2. Plaza ===
        if (dato.plaza) {
          const plaza = await getPlazavistaOptimized(dato.plaza);
          if (plaza) {
            form.setFieldsValue({
              tipo_empleado: plaza.tipo_de_empleado,
              categoria: plaza.categoria_de_empleado,
              tipo_de_contratacion: plaza.tipo_de_contratacion_descripcion,
              tipo_de_actividad: plaza.tipo_de_actividad_id,
              tiempo_de_contratacion: plaza.tiempo_de_contratacion,
              tipo_de_nomina_empleado: plaza.tipo_nomina_empleado,
              tipo_regimen_nomina: plaza.tipo_de_regimen_nomina,
              zonasDeSalariosMinimos: plaza.zona_de_salario_minimo_descripcion,
            });
          }
        }

        // === 3. Jornada (si ya hay jornada en el form) ===
        const jornadaId = form.getFieldValue('jornada');
        const jornadaSeleccionada = jornadas.find((j) => j.id === jornadaId);

        if (jornadaSeleccionada) {
          form.setFieldsValue({
            numero_horas_semanales: jornadaSeleccionada.horas_desde,
          });
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('[Atributos del Empleado] error al cargar datos operacionales/plaza', error);
      }
    };

    fetch();
  }, [empleado, form, jornadas]);

  useEffect(() => {
    if (tiposOrigenesContratacion?.length > 0 && origenContratacionSeleccionado) {
      // Buscamos el nombre en el catálogo usando el ID que nos pasó el padre
      const match = tiposOrigenesContratacion.find(
        (item) => item.id === origenContratacionSeleccionado,
      );

      form.setFieldsValue({
        tipo_de_origen_de_contratacion: match ? match.descripcion : 'No especificado',
      });
    } else {
      // Si es nuevo o no tiene dato
      form.setFieldsValue({
        tipo_de_origen_de_contratacion: '',
      });
    }
  }, [tiposOrigenesContratacion, origenContratacionSeleccionado, form]);

  return (
    <Form layout="vertical" form={form} scrollToFirstError name="general">
      <Form.Item noStyle shouldUpdate>
        {() => {
          const tipoEmpleadoVal = form.getFieldValue('tipo_empleado');
          const tipoNominaVal = form.getFieldValue('tipo_de_nomina_empleado');
          const subtitulo = [
            tiposEmpleados?.find((e) => e.id === tipoEmpleadoVal)?.descripcion || tipoEmpleadoVal,
            form.getFieldValue('categoria'),
            tiposDeNominasEmpleados?.find((e) => e.id === tipoNominaVal)?.descripcion || tipoNominaVal,
          ].filter(Boolean).join(' · ');
          return (
            <Card
              size="small"
              className="inner-block-card"
            >
              <Typography.Text strong style={{ fontSize: 16, display: 'block' }}>
                {[
                  formGeneral?.getFieldValue('nombre'),
                  formGeneral?.getFieldValue('apellido_paterno'),
                  formGeneral?.getFieldValue('apellido_materno'),
                ].filter(Boolean).join(' ')}
              </Typography.Text>
              <Typography.Text type="secondary">
                {subtitulo}
              </Typography.Text>
            </Card>
          );
        }}
      </Form.Item>
      <Card
        type="inner"
        size="small"
        className="inner-block-card"
        title="1. Contratación"
        extra="Tipo, Tiempo, Nómina Y Origen"
      >
        <Row gutter={10}>
          <Col xs={24} sm={24} md={8}>
            <Form.Item
              name="tipo_de_origen_de_contratacion"
              label="Tipo de Origen de Contratación"
              hasFeedback
            >

              <Input disabled />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item
              name="tipo_empleado"
              label="Tipo de Empleado"
              // rules={rules.required}
              hasFeedback
            >
              <Select
                labelProp="descripcion"
                keyProp="id"
                dataSource={tiposEmpleados}
                disabled
              />
            </Form.Item>
          </Col>
          {/* //? Hay un catalogo? */}
          <Col xs={24} sm={24} md={8}>
            <Form.Item
              name="categoria"
              label="Categoria de Empleado"
              // rules={rules.required}
              hasFeedback
            >
              <Select
                labelProp="descripcion"
                keyProp="id"
                dataSource={[]}
                disabled
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item
              name="tiempo_de_contratacion"
              label="Tiempo de Contratación"
              // rules={rules.required}
              hasFeedback
            >
              <Select
                labelProp="descripcion"
                keyProp="id"
                dataSource={tiemposDeContrataciones}
                disabled
              />
            </Form.Item>
          </Col>
          {/* //? Hay un catalogo? */}
          <Col xs={24} sm={24} md={8}>
            <Form.Item
              name="tipo_de_contratacion"
              label="Tipo de Contratación"
              // rules={rules.required}
              hasFeedback
            >
              <Input disabled />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item name="tipo_de_nomina_empleado" label="Tipo de Nómina Empleado" hasFeedback>
              <Select
                labelProp="descripcion"
                keyProp="id"
                dataSource={tiposDeNominasEmpleados}
                onChange={(value) => {
                  const tipo = tiposDeNominasEmpleados.find((e) => e.id === value);
                  if (tipo?.habilitado) {
                    form.setFieldValue('periodicidad_de_pago', tipo.periodicidad_de_pago);
                  } else {
                    onAlert(`El Tipo de Nómina Empleado ${tipo?.descripcion} se encuentra cerrado`);
                    form.resetFields(['tipo_de_nomina_empleado']);
                  }
                }}
                disabled
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item
              name="tipo_de_actividad"
              label="Tipo de Actividad"
              // rules={rules.required}
              hasFeedback
            >
              <Select
                labelProp="concepto"
                keyProp="id"
                dataSource={tipodeActividades}
                disabled
              />
            </Form.Item>
          </Col>
        </Row>
      </Card>
      <Card
        type="inner"
        size="small"
        className="inner-block-card"
        title="2. Régimen Fiscal Y Sueldo"
        extra="SAT, Tipo De Sueldo, Periodicidad Y Zona"
      >
        <Row gutter={10}>
          <Col xs={24} sm={24} md={24}>
            <Form.Item name="tipo_regimen_nomina" label="Tipo de Régimen del SAT" hasFeedback>
              <Select
                labelProp="descripcion"
                keyProp="id"
                dataSource={tiposRegimenesNominas}
                render={(val) => `${val?.clave} - ${val?.descripcion}`}
                disabled
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item name="tipo_de_sueldo" label="Tipo de Sueldo" hasFeedback>
              <Select
                labelProp="descripcion"
                keyProp="id"
                dataSource={tiposDeSueldos}
                disabled
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item name="periodicidad_de_pago" label="Periodicidad de Pago" hasFeedback>
              <Select labelProp="descripcion" keyProp="id" dataSource={perioricidadesDePago} disabled />
            </Form.Item>
            {' '}
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item name="zona_de_salario_minimo" label="Zona de Salario Mínimo" hasFeedback>
              <Select labelProp="descripcion" keyProp="id" dataSource={zonasDeSalariosMinimos} disabled />
            </Form.Item>
          </Col>
        </Row>
      </Card>
      <Card
        type="inner"
        size="small"
        className="inner-block-card"
        title="3. Nombramiento"
        extra="Tipo, Folio Y Vigencia"
      >
        <Row gutter={10}>
          <Col xs={24} sm={24} md={8}>
            <Form.Item name="tipo_de_nombramiento" label="Tipo de Nombramiento">
              <Select
                labelProp="descripcion"
                keyProp="id"
                dataSource={caracteresDeNombramiento}
                onChange={(value) => {
                  const caracter = caracteresDeNombramiento.find((c) => c.id === value);
                  form.setFieldsValue({
                    folio_de_nombramiento: `FOLIO-${value}`,
                    vigencia_de_nombramiento_inicio: moment(caracter?.vigencia_inicial),
                    vigencia_de_nombramiento_fin: caracter?.vigencia_final ? moment(caracter.vigencia_final) : null,
                  });
                }}
                disabled
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item name="folio_de_nombramiento" label="Folio de Nombramiento">
              <Input disabled />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item label="Vigencia de Nombramiento">
              <Input.Group compact>
                <Form.Item name="vigencia_de_nombramiento_inicio" noStyle>
                  <DatePicker
                    format="DD/MM/YYYY"
                    disabled
                    style={{ width: '50%' }}
                  />
                </Form.Item>
                <Form.Item name="vigencia_de_nombramiento_fin" noStyle>
                  <DatePicker format="DD/MM/YYYY" disabled style={{ width: '50%' }} />
                </Form.Item>
              </Input.Group>
            </Form.Item>
          </Col>
        </Row>
      </Card>
      <Card
        type="inner"
        size="small"
        className="inner-block-card"
        title="4. Jornada Y Asistencia"
        extra="Horario, Horas Semanales Y Checador"
      >
        <Row gutter={10}>
          <Col xs={24} sm={24} md={8}>
            <Form.Item name="jornada" label="Jornada" hasFeedback>
              <Select
                labelProp="descripcion"
                keyProp="id"
                dataSource={jornadas}
                onChange={() => {
                  form.setFieldsValue({ jornada_detalle: undefined, total_horas_solo_hrs: undefined });
                }}
                disabled={isBlocked}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item noStyle shouldUpdate={(prev, curr) => prev.jornada !== curr.jornada}>
              {() => {
                const jornadaSeleccionada = form.getFieldValue('jornada');
                const opcionesHorario = jornadaDetalles.filter(
                  (jd) => jd.jornada === jornadaSeleccionada,
                );
                return (
                  <Form.Item name="jornada_detalle" label="Horario" hasFeedback>
                    <Select
                      labelProp="descripcion_rango_horario"
                      keyProp="id"
                      dataSource={opcionesHorario}
                      onChange={(value) => {
                        const detalle = jornadaDetalles.find((jd) => jd.id === value);
                        form.setFieldsValue({
                          total_horas_solo_hrs: detalle?.total_horas_solo_hrs,
                        });
                      }}
                      disabled={isBlocked || !jornadaSeleccionada}
                    />
                  </Form.Item>
                );
              }}
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item name="total_horas_solo_hrs" label="Número de Horas Semanal">
              <InputNumber disabled style={{ width: '100%' }} />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item name="aplica_reloj_checador" label="Aplica Reloj Checador">
              <Select trueFalse disabled={isBlocked} />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item name="tipo_de_checado" label="Tipo de Checado">
              <Select labelProp="nombre" keyProp="id" dataSource={tiposDeChecado} disabled={isBlocked} />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item label=" ">
              <Button
                onClick={guardarHorario}
                loading={guardandoHorario}
                disabled={isBlocked || !datoOperacionalId}
              >
                Guardar Horario
              </Button>
            </Form.Item>
          </Col>
        </Row>
        <Table
          titleTable="Historial de Horario"
          cols={historialHorarioCols}
          data={historialHorario}
          rowKey="id"
          pagination={false}
          rowSelection={{
            selectedRowKeys: selectedHistorialHorarioKeys,
            onChange: (keys, rows) => {
              setSelectedHistorialHorarioKeys(keys);
              setHistorialHorarioSeleccionado(rows[0] || null);
            },
            type: 'radio',
          }}
          handleOnRowClick={(record) => {
            setSelectedHistorialHorarioKeys([record.id]);
            setHistorialHorarioSeleccionado(record);
          }}
          controls={{
            onClickEdit: handleEditHistorialHorario,
            onClickDelete: () => setVisibleDeleteHistorialHorario(true),
          }}
          allowAdd={false}
          permission={permissionHistorialHorario}
        />
        <Modal
          open={editHistorialHorarioVisible}
          closable={false}
          maskClosable={!guardandoEdicionHistorial}
          keyboard={!guardandoEdicionHistorial}
          footer={null}
          title={(
            <FormSubmitControls
              label="Editar Historial de Horario"
              onFinish={handleGuardarEdicionHistorial}
              onCancel={() => setEditHistorialHorarioVisible(false)}
              loading={guardandoEdicionHistorial}
            />
          )}
          onCancel={() => setEditHistorialHorarioVisible(false)}
          destroyOnClose
        >
          <Form layout="vertical" form={editHistorialForm}>
            <Form.Item name="jornada" label="Jornada" rules={rules.required}>
              <Select
                labelProp="descripcion"
                keyProp="id"
                dataSource={jornadas}
                onChange={() => editHistorialForm.setFieldsValue({ jornada_detalle: undefined })}
              />
            </Form.Item>
            <Form.Item noStyle shouldUpdate={(prev, curr) => prev.jornada !== curr.jornada}>
              {() => {
                const jornadaEditSeleccionada = editHistorialForm.getFieldValue('jornada');
                const opcionesHorarioEdit = jornadaDetalles.filter(
                  (jd) => jd.jornada === jornadaEditSeleccionada,
                );
                return (
                  <Form.Item name="jornada_detalle" label="Horario" rules={rules.required}>
                    <Select
                      labelProp="descripcion_rango_horario"
                      keyProp="id"
                      dataSource={opcionesHorarioEdit}
                      disabled={!jornadaEditSeleccionada}
                    />
                  </Form.Item>
                );
              }}
            </Form.Item>
            <Form.Item name="aplica_reloj_checador" label="Aplica Reloj Checador">
              <Select trueFalse />
            </Form.Item>
            <Form.Item name="tipo_de_checado" label="Tipo de Checado">
              <Select labelProp="nombre" keyProp="id" dataSource={tiposDeChecado} />
            </Form.Item>
            <Form.Item name="fecha_de_cambio" label="Fecha de Cambio" rules={rules.required}>
              <DatePicker format="DD/MM/YYYY" style={{ width: '100%' }} />
            </Form.Item>
          </Form>
        </Modal>
        <ModalDelete
          open={visibleDeleteHistorialHorario}
          onCancel={() => setVisibleDeleteHistorialHorario(false)}
          onDelete={confirmDeleteHistorialHorario}
          content={`el registro de horario del ${historialHorarioSeleccionado?.fecha_de_cambio || ''}`}
          loading={eliminandoHistorialHorario}
        />
      </Card>
      <Card
        type="inner"
        size="small"
        className="inner-block-card"
        title="5. Sindicato"
        extra="Afiliación Sindical Del Empleado"
      >
        <Row gutter={10}>
          <Col xs={24} sm={24} md={12}>
            <Form.Item name="sindicalizado" label="Sindicalizado" hasFeedback initialValue={false}>
              <Select
                trueFalse
                onChange={(value) => {
                  setSindicalizado(value);
                  if (!value) {
                    form.resetFields(['sindicato']);
                  }
                }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12}>
            <Form.Item name="sindicato" label="Sindicato" rules={sindicalizado ? rules.required : null} hasFeedback>
              <Select labelProp="descripcion" keyProp="id" dataSource={sindicatos} disabled={!sindicalizado} />
            </Form.Item>
          </Col>
        </Row>
      </Card>
    </Form>
  );
};

export default EmpleadoAtributos;
